"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatHotelFilterData = formatHotelFilterData;
exports.formatHotelReview = formatHotelReview;
exports.formatHotelSortData = formatHotelSortData;
exports.formatHotelTopPick = formatHotelTopPick;
exports.formatRateInfo = formatRateInfo;
exports.hotelSummaryCardFactory = hotelSummaryCardFactory;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _toNumber2 = _interopRequireDefault(require("lodash/toNumber"));
var _reduce2 = _interopRequireDefault(require("lodash/reduce"));
var _isObject2 = _interopRequireDefault(require("lodash/isObject"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _values2 = _interopRequireDefault(require("lodash/values"));
var _some2 = _interopRequireDefault(require("lodash/some"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _constants2 = require("../constants");
var _search = require("../utils/search.utils");
var _language = require("../utils/language.utils");
var _hotelDetails = require("../utils/hotel-details.utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * hotel summary factory for [hotel search results card]
 * @param {Object} dynamicHotel
 * @param {Object} staticHotel
 * @param {Object} staticResources
 * @param {Object} request
 * @param {String} sId
 * @param {String} language
 * @param {String} currency
 * @param {String} distanceDetails
 * @param {Function} formatPrice
 * @param {Function} convertPrice
 * @param {Boolean} isTajawal
 * @param {Boolean} isDev
 * @param {Boolean} pollingCompleted
 * @param {Boolean} isDesktop
 * @return {Object}
 */
function hotelSummaryCardFactory(_ref) {
  var _staticHotel$addition, _staticHotel$addition2, _staticHotel$images;
  var primaryCityId = _ref.primaryCityId,
    _ref$dynamicHotel = _ref.dynamicHotel,
    dynamicHotel = _ref$dynamicHotel === void 0 ? {} : _ref$dynamicHotel,
    _ref$staticHotel = _ref.staticHotel,
    staticHotel = _ref$staticHotel === void 0 ? {} : _ref$staticHotel,
    _ref$staticResources = _ref.staticResources,
    staticResources = _ref$staticResources === void 0 ? {} : _ref$staticResources,
    _ref$request = _ref.request,
    request = _ref$request === void 0 ? {} : _ref$request,
    sId = _ref.sId,
    language = _ref.language,
    currency = _ref.currency,
    formatPrice = _ref.formatPrice,
    convertPrice = _ref.convertPrice,
    isTajawal = _ref.isTajawal,
    isDev = _ref.isDev,
    pollingCompleted = _ref.pollingCompleted,
    distanceDetails = _ref.distanceDetails,
    distanceDetailsInMeters = _ref.distanceDetailsInMeters,
    isDesktop = _ref.isDesktop,
    showPricePerNight = _ref.showPricePerNight,
    isRtl = _ref.isRtl,
    staticLandmarksHashMap = _ref.staticLandmarksHashMap;
  var dynamicHotelId = dynamicHotel.hotelId,
    finalRate = dynamicHotel.basePrice,
    discountPercentage = dynamicHotel.discountPercentage,
    boards = dynamicHotel.boards,
    roomBasis = dynamicHotel.roomBasis,
    freeCancellation = dynamicHotel.freeCancellation,
    showDiscount = dynamicHotel.showDiscount,
    supplierName = dynamicHotel.supplierName;
  var propertyTypesHashMap = staticResources.propertyTypesHashMap,
    chainsHashMap = staticResources.chainsHashMap,
    reviewScaleHashMap = staticResources.reviewScaleHashMap,
    propertyTypesHashMapEn = staticResources.propertyTypesHashMapEn;
  var _reviewScaleHashMap = (0, _slicedToArray2["default"])(reviewScaleHashMap, 2),
    reviewsScaleOfTen = _reviewScaleHashMap[1];
  var starRating = staticHotel.starRating,
    propertyTypeId = staticHotel.propertyTypeId,
    staticHotelId = staticHotel.atgHotelId,
    latitude = staticHotel.latitude,
    longitude = staticHotel.longitude,
    distanceInKm = staticHotel.distance,
    hotelChainId = staticHotel.hotelChainId,
    showDistance = staticHotel.showDistance,
    distanceInMeters = staticHotel.distanceInMeters,
    landmarkDistanceInMeter = staticHotel.landmarkDistanceInMeter;
  var stayingNights = request.stayingNights;
  var hotelId = dynamicHotelId || staticHotelId;
  var flaggedSubCategory = (0, _get2["default"])(staticHotel, 'review.flaggedSubCategory', null);
  // hotel status
  var hasStaticContent = !(0, _isEmpty2["default"])(staticHotel);
  var facilityIds = (0, _get2["default"])(staticHotel, 'facilityIds');
  var isPriceFetched = !(0, _isEmpty2["default"])(dynamicHotel);
  var soldOut = hasStaticContent && !isPriceFetched && pollingCompleted;
  var chain = (0, _pick2["default"])(chainsHashMap[hotelChainId], ['id', 'name']);
  var distance = distanceDetails ? distanceInKm < 1 ? "".concat(distanceInMeters).concat(distanceDetailsInMeters) : "".concat(distanceInKm).concat(distanceDetails) : null;
  var distanceInNumber = distanceInKm || 0;
  var propertyType = (0, _get2["default"])(propertyTypesHashMap[propertyTypeId], 'name', null);
  var propertyTypeEn = (0, _get2["default"])(propertyTypesHashMapEn[propertyTypeId], 'name', null);
  var hotelName = (0, _language.translateObjectLabel)((0, _get2["default"])(staticHotel, 'name'), language);
  var hotelNameEn = (0, _get2["default"])(staticHotel, 'name.en');
  var address = (0, _language.translateObjectLabel)((0, _get2["default"])(staticHotel, 'address'), language);
  var trustYouReviews = formatHotelReview({
    staticHotel: staticHotel,
    language: language,
    reviewsScaleOfTen: reviewsScaleOfTen
  });
  var topPick = formatHotelTopPick({
    staticHotel: staticHotel,
    language: language
  });
  var hotelCity = (0, _get2["default"])(staticHotel, 'city', {});
  var additionalBookingHistory = (0, _get2["default"])(staticHotel.additionalData, 'bookingHistory', null);
  var hotelCityName = language === _constants.LANGUAGE.AR ? hotelCity === null || hotelCity === void 0 ? void 0 : hotelCity.nameAr : hotelCity === null || hotelCity === void 0 ? void 0 : hotelCity.nameEn;
  var bookingHistoryPopular = staticHotel !== null && staticHotel !== void 0 && (_staticHotel$addition = staticHotel.additionalData) !== null && _staticHotel$addition !== void 0 && _staticHotel$addition.bookingHistory ? (0, _search.getPopularTag)({
    city: hotelCity,
    bookingHistory: staticHotel === null || staticHotel === void 0 ? void 0 : (_staticHotel$addition2 = staticHotel.additionalData) === null || _staticHotel$addition2 === void 0 ? void 0 : _staticHotel$addition2.bookingHistory
  }) : null;
  var coverImg = (0, _get2["default"])(staticHotel, 'thumbnailUrl');
  var coverImgMedium = (0, _get2["default"])(staticHotel, 'thumbnailUrl');
  var hotelCardImgsList = staticHotel === null || staticHotel === void 0 ? void 0 : (_staticHotel$images = staticHotel.images) === null || _staticHotel$images === void 0 ? void 0 : _staticHotel$images.map(function (i) {
    return {
      src: i
    };
  });
  var placeHolderImage = (0, _get2["default"])(staticHotel, 'thumbnailUrl');

  // TO DO - END- NEXTJS Images

  var hasHealthAndSafetyMeasure = (0, _some2["default"])(facilityIds, function (facilityId) {
    return facilityId >= _constants2.HEALTH_AND_SAFETY_MINIMUM_ID;
  });
  var rateInfo = formatRateInfo({
    formatPrice: formatPrice,
    currency: currency,
    stayingNights: stayingNights,
    dynamicHotel: dynamicHotel
  });
  var sortData = formatHotelSortData({
    finalRate: finalRate,
    staticHotel: staticHotel
  });
  var filterData = formatHotelFilterData({
    hotelName: (0, _get2["default"])(staticHotel, 'name'),
    convertPrice: convertPrice,
    stayingNights: stayingNights,
    dynamicHotel: dynamicHotel,
    staticHotel: staticHotel,
    staticResources: staticResources,
    topPick: topPick,
    soldOut: soldOut,
    language: language,
    hasHealthAndSafetyMeasure: hasHealthAndSafetyMeasure,
    staticLandmarksHashMap: staticLandmarksHashMap
  });
  var perNightRateInfo = rateInfo.perNightRateInfo,
    totalRateInfo = rateInfo.totalRateInfo;
  var priceCondition = discountPercentage > 0 && showDiscount == false;
  var displayPrice = showPricePerNight ? priceCondition ? perNightRateInfo === null || perNightRateInfo === void 0 ? void 0 : perNightRateInfo.finalRate : perNightRateInfo === null || perNightRateInfo === void 0 ? void 0 : perNightRateInfo.originalRate : priceCondition ? totalRateInfo === null || totalRateInfo === void 0 ? void 0 : totalRateInfo.finalRate : totalRateInfo === null || totalRateInfo === void 0 ? void 0 : totalRateInfo.originalRate;
  var displayDiscount = showPricePerNight ? perNightRateInfo === null || perNightRateInfo === void 0 ? void 0 : perNightRateInfo.discount : totalRateInfo === null || totalRateInfo === void 0 ? void 0 : totalRateInfo.discount;
  var displayDiscountedPrice = showPricePerNight ? perNightRateInfo === null || perNightRateInfo === void 0 ? void 0 : perNightRateInfo.finalRate : totalRateInfo === null || totalRateInfo === void 0 ? void 0 : totalRateInfo.finalRate;
  return _objectSpread(_objectSpread({
    reviewsScaleOfTen: reviewsScaleOfTen,
    hotelId: hotelId,
    flaggedSubCategory: flaggedSubCategory,
    sId: sId,
    hotelName: hotelName,
    hotelNameEn: hotelNameEn,
    propertyType: propertyType,
    propertyTypeEn: propertyTypeEn,
    isApartmentProperty: (0, _includes2["default"])(_constants2.APARTMENT_PROPERTY_TYPES, propertyTypeId),
    starRating: starRating || 0,
    coordinates: {
      lat: latitude,
      lng: longitude
    },
    address: address,
    distance: distance,
    distanceInNumber: distanceInNumber,
    latitude: latitude,
    longitude: longitude,
    freeCancellation: Boolean(freeCancellation),
    priceIncludesBreakfast: roomBasis === _constants2.ROOM_BASIS.BB,
    hasBreakfast: (0, _includes2["default"])(boards, _constants2.ROOM_BASIS.BB),
    coverImg: coverImg,
    coverImgMedium: coverImgMedium,
    hotelCardImgsList: hotelCardImgsList,
    placeHolderImage: placeHolderImage,
    currency: currency,
    totalDiscount: discountPercentage,
    showDiscount: showDiscount,
    soldOut: soldOut,
    stayingNights: stayingNights,
    supplierName: supplierName,
    trustYouReviews: trustYouReviews,
    topPick: topPick,
    chain: chain,
    hotelDetailUrl: (0, _search.getHotelDetailUrl)({
      language: language,
      hotelId: hotelId,
      sId: sId,
      request: request,
      isPriceFetched: isPriceFetched
    }),
    sortData: sortData,
    filterData: filterData,
    hasStaticContent: hasStaticContent,
    isPriceFetched: isPriceFetched
  }, rateInfo), {}, {
    hasHealthAndSafetyMeasure: hasHealthAndSafetyMeasure,
    hotelCity: hotelCity,
    additionalBookingHistory: additionalBookingHistory,
    bookingHistoryPopular: bookingHistoryPopular,
    showDistance: showDistance,
    hotelCityName: hotelCityName,
    displayPrice: displayPrice,
    displayDiscount: displayDiscount,
    displayDiscountedPrice: displayDiscountedPrice,
    landmarkDistanceInMeter: landmarkDistanceInMeter
  });
}

/**
 * format sort data
 * @param {Number} finalRate
 * @param {Object} staticHotel
 * @return {Object}
 */
function formatHotelSortData(_ref2) {
  var finalRate = _ref2.finalRate,
    staticHotel = _ref2.staticHotel;
  return {
    price: finalRate || null,
    priority: (0, _get2["default"])(staticHotel, 'priorityScore', 0),
    distance: (0, _get2["default"])(staticHotel, 'distanceScore', 0),
    reviews: (0, _get2["default"])(staticHotel, 'review.score', 0)
  };
}

/**
 * format hotel filter data
 * @param {{id, category, categoryIcon}} topPick
 * @param {String} hotelName
 * @param {Function} convertPrice
 * @param {Number} stayingNights
 * @param {Object} dynamicHotel
 * @param {Object} staticHotel
 * @param {Object} staticResources
 * @param {String} language
 * @param {Boolean} soldOut
 * @param {Boolean} outOfPolicy
 * @return {Object}
 */
function formatHotelFilterData(_ref3) {
  var topPick = _ref3.topPick,
    hotelName = _ref3.hotelName,
    convertPrice = _ref3.convertPrice,
    stayingNights = _ref3.stayingNights,
    dynamicHotel = _ref3.dynamicHotel,
    staticHotel = _ref3.staticHotel,
    staticResources = _ref3.staticResources,
    soldOut = _ref3.soldOut,
    language = _ref3.language,
    hasHealthAndSafetyMeasure = _ref3.hasHealthAndSafetyMeasure,
    staticLandmarksHashMap = _ref3.staticLandmarksHashMap;
  var boards = dynamicHotel.boards,
    finalRate = dynamicHotel.basePrice,
    perNightFinalRate = dynamicHotel.basePriceNightlyRate,
    freeCancellation = dynamicHotel.freeCancellation,
    outOfPolicy = dynamicHotel.outOfPolicy;
  var amenitiesHashMap = staticResources.amenitiesHashMap,
    chainsHashMap = staticResources.chainsHashMap,
    propertyTypesHashMap = staticResources.propertyTypesHashMap;
  var starRating = staticHotel.starRating,
    facilityIds = staticHotel.facilityIds,
    hotelChainId = staticHotel.hotelChainId,
    propertyTypeId = staticHotel.propertyTypeId,
    area = staticHotel.area,
    landmarkDistanceInMeter = staticHotel.landmarkDistanceInMeter;
  var propertyAmenitiesIds = (0, _filter2["default"])(facilityIds, function (i) {
    return i < _constants2.MINIMUM_ID_FOR_COVID_FACILITIES;
  });
  return {
    hotelName: (0, _values2["default"])(hotelName).join('|'),
    priceData: finalRate ? {
      totalPrice: Math.round(convertPrice(finalRate)),
      perNightPrice: Math.round(convertPrice(perNightFinalRate))
    } : null,
    starRating: starRating || 0,
    guestRating: (0, _get2["default"])(staticHotel, 'review.score', 0),
    propertyAmenities: (0, _reduce2["default"])(propertyAmenitiesIds, function (amenities, id) {
      if ((0, _isEmpty2["default"])(amenitiesHashMap[id])) return amenities;
      var _amenitiesHashMap$id = amenitiesHashMap[id],
        name = _amenitiesHashMap$id.name,
        blackIcon = _amenitiesHashMap$id.blackIcon;
      return amenities.concat({
        id: id,
        name: name,
        icon: blackIcon
      });
    }, []),
    propertyType: (0, _pick2["default"])(propertyTypesHashMap[propertyTypeId], ['id', 'name']),
    availableBoards: boards || [],
    chain: (0, _pick2["default"])(chainsHashMap[hotelChainId], ['id', 'name']),
    topPick: topPick ? {
      id: topPick.id,
      name: topPick.category,
      icon: topPick.categoryIcon
    } : null,
    soldOut: soldOut,
    district: area ? {
      id: area.id,
      name: (0, _language.translate2keysLabel)(area, 'name', language)
    } : null,
    hasFreeCancellation: !!freeCancellation,
    hasHealthAndSafetyMeasure: hasHealthAndSafetyMeasure,
    outOfPolicy: outOfPolicy,
    landmarks: landmarksArray(mapLandmarksToLandmarkInMeter(staticLandmarksHashMap, landmarkDistanceInMeter))
  };
}
function landmarksArray(landmarks) {
  return (0, _map2["default"])(landmarks, function (value, key) {
    return {
      id: (0, _toNumber2["default"])(key),
      name: value.landmark,
      distance: value.distance,
      position: value.position
    };
  });
}
function mapLandmarksToLandmarkInMeter() {
  var staticLandmarksHashMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var landmarkDistanceInMeter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _isObject2["default"])(landmarkDistanceInMeter) ? (0, _reduce2["default"])(landmarkDistanceInMeter, function (result, distance, key) {
    if (staticLandmarksHashMap[key]) {
      var _staticLandmarksHashM, _staticLandmarksHashM2;
      result[key] = {
        distance: distance,
        position: (_staticLandmarksHashM = staticLandmarksHashMap[key]) === null || _staticLandmarksHashM === void 0 ? void 0 : _staticLandmarksHashM.position,
        landmark: (_staticLandmarksHashM2 = staticLandmarksHashMap[key]) === null || _staticLandmarksHashM2 === void 0 ? void 0 : _staticLandmarksHashM2.name
      };
    }
    return result;
  }, {}) : [];
}

/**
 * format hotel top pick
 * @param {Object} staticHotel
 * @param {String} language
 * @return {Object|null}
 */
function formatHotelTopPick(_ref4) {
  var staticHotel = _ref4.staticHotel,
    language = _ref4.language;
  var topPicks = (0, _get2["default"])(staticHotel, 'topPicks');
  return topPicks ? {
    id: (0, _get2["default"])(topPicks, 'categories.en'),
    description: (0, _language.translateObjectLabel)((0, _get2["default"])(topPicks, 'description'), language),
    distance: (0, _language.translateObjectLabel)((0, _get2["default"])(topPicks, 'distance'), language),
    subCategory: (0, _language.translateObjectLabel)((0, _get2["default"])(topPicks, 'subcategories'), language),
    category: (0, _language.translateObjectLabel)((0, _get2["default"])(topPicks, 'categories'), language),
    categoryIcon: (0, _get2["default"])(topPicks, 'categories.iconLink')
  } : null;
}

/**
 * format hotel review
 * @param {Object} staticHotel
 * @param {String} language
 * @return {Object}
 */
function formatHotelReview(_ref5) {
  var staticHotel = _ref5.staticHotel,
    language = _ref5.language,
    reviewsScaleOfTen = _ref5.reviewsScaleOfTen;
  var trustyouReview = (0, _get2["default"])(staticHotel, 'review');
  var score = parseFloat((0, _get2["default"])(trustyouReview, 'score')).toFixed(1);
  var chargedReview = (0, _hotelDetails.getReviewScoreMeta)(score, reviewsScaleOfTen);
  return {
    count: (0, _get2["default"])(trustyouReview, 'count'),
    name: (0, _get2["default"])(chargedReview, 'name'),
    sourcesCount: (0, _get2["default"])(trustyouReview, 'sourcesCount'),
    score: score,
    scoreDescription: (0, _language.translateObjectLabel)((0, _get2["default"])(trustyouReview, 'scoreDescription'), language),
    color: (0, _get2["default"])(chargedReview, 'color')
  };
}

/**
 * format rate info
 *
 * @param {Function} formatPrice
 * @param {String} currency
 * @param {Number} originalRate
 * @param {Number} stayingNights
 * @param {Object} dynamicHotel
 * @return {Object}
 */
function formatRateInfo(_ref6) {
  var formatPrice = _ref6.formatPrice,
    currency = _ref6.currency,
    stayingNights = _ref6.stayingNights,
    dynamicHotel = _ref6.dynamicHotel;
  var originalRate = dynamicHotel.firstPrice,
    finalRate = dynamicHotel.basePrice,
    perNightOriginalRate = dynamicHotel.firstPriceNightlyRate,
    perNightFinalRate = dynamicHotel.basePriceNightlyRate,
    discountPercentage = dynamicHotel.discountPercentage,
    showDiscount = dynamicHotel.showDiscount,
    discountPrice = dynamicHotel.discountPrice;
  var discount = showDiscount ? discountPercentage : 0;
  var hotelDiscountPrice = showDiscount ? formatPrice(discountPrice, 0) : 0;
  if (!finalRate) {
    return {
      rateInfo: null,
      totalRateInfo: null,
      perNightRateInfo: null,
      showDiscount: null,
      discount: null
    };
  }
  return {
    rateInfo: {
      finalRate: finalRate,
      originalRate: originalRate,
      discount: discount,
      currency: currency,
      showDiscount: showDiscount
    },
    totalRateInfo: {
      finalRate: formatPrice(finalRate, 0),
      originalRate: formatPrice(originalRate, 0),
      discount: discount,
      currency: currency,
      hotelDiscountPrice: hotelDiscountPrice
    },
    perNightRateInfo: {
      finalRate: formatPrice(perNightFinalRate, 0),
      originalRate: formatPrice(perNightOriginalRate, 0),
      discount: discount,
      currency: currency
    }
  };
}